import React from "react";
import ApproveButton from "@components/FlowActionButtons/ApproveButton";
import type { VendorLicenseTask } from "@services/licensing/types";
import { canUserApprove } from "../utils";

export interface LicenseFlowData {
  id: string;
  status: string;
  task: VendorLicenseTask | null;
}

interface ApproveLicenseProps {
  licenseFlowData?: LicenseFlowData;
  openDrawer: (drawerName: string) => void;
}

const LANG_BASE = "licensing";

const ApproveLicense: React.FC<ApproveLicenseProps> = ({ licenseFlowData, openDrawer }) => {
  if (!licenseFlowData || !licenseFlowData.task) return null;

  const isActionAvailable = Boolean(
    canUserApprove(
      licenseFlowData.task.status,
      licenseFlowData.task.claimOwnerName,
      licenseFlowData.status,
    ),
  );

  return (
    <ApproveButton
      langBase={LANG_BASE}
      permission={["canApprovePortOperatorLicense", "canApproveVendorLicense"]}
      isActionAvailable={isActionAvailable}
      onApprove={() => openDrawer("approveDrawer")}
    />
  );
};

export default ApproveLicense;
